<template>
  <el-dialog :visible.sync="visible" width="90%" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="productionIssue" :biz-id="form.id" perm="production:productionIssue" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" @done="onWorkflowDone" />
            <el-button v-if="(isAuth('production:productionIssue:update') || isAuth('production:productionIssue:save')) && form.approveStatus !== '2'" type="primary" size="small" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('production:productionIssue:delete') && form.approveStatus !== '2'" type="primary" size="small" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="6"><el-form-item label="领料单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id" placeholder="留空自动编号" /></el-form-item></el-col>
        <el-col :span="6"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>
        <el-col :span="8">
          <el-form-item label="生产工单" prop="orderIds">
            <el-input :value="orderSummary" readonly placeholder="选择工单（可多选）">
              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="!formDisabled">
          <el-form-item label-width="0px">
            <el-button type="primary" size="small" :disabled="!(form.orderIds && form.orderIds.length)" @click="fillBom">按BOM带出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注"><el-input v-model="form.remark" :disabled="formDisabled" /></el-form-item>
      <div v-if="!formDisabled && !(form.orderIds && form.orderIds.length)" style="margin-bottom:8px">
        <el-button type="primary" size="small" @click="form.lines.push(blankLine())">添加行</el-button>
      </div>
      <el-table :key="formDisabled ? 'issue-view' : 'issue-edit'" ref="issueLinesTable" :data="form.lines" border :header-cell-style="headStyle">
        <el-table-column label="子件编码" min-width="120" header-align="center" align="left">
          <template slot-scope="s">
            <span v-if="form.orderIds && form.orderIds.length">{{ s.row.materialCode }}</span>
            <el-input v-else v-model="s.row.materialCode" size="small" :disabled="formDisabled" @blur="fillMaterial(s.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="materialName" label="子件名称" min-width="140" header-align="center" align="left" />
        <el-table-column prop="requiredQty" label="需求" width="90" header-align="center" align="left" />
        <el-table-column prop="remainIssueQty" label="可领" width="90" header-align="center" align="left" />
        <el-table-column v-if="!formDisabled" prop="usableQuantity" label="可用库存" width="110" header-align="center" align="left">
          <template slot="header">
            <span>可用库存</span>
            <el-tooltip content="未选库位时为全组织汇总；选定库位后为该库位可用量" placement="top">
              <i class="el-icon-info" style="margin-left:4px;color:#909399;" />
            </el-tooltip>
          </template>
          <template slot-scope="s">
            <span :class="{ 'qty-warn': usableShort(s.row) }">{{ formatUsable(s.row.usableQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="领料数量" width="160" header-align="center" align="left">
          <template slot-scope="s">
            <span v-if="formDisabled">{{ formatUsable(s.row.quantity) }}</span>
            <el-input-number v-else v-model="s.row.quantity" :min="0" :max="!form.id && form.orderIds && form.orderIds.length && s.row.remainIssueQty != null ? Number(s.row.remainIssueQty) : undefined" :precision="2" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column v-if="form.orderIds && form.orderIds.length > 1" label="来源工单" min-width="140" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="s">{{ (s.row.allocs || []).map(item => item.productionOrderCode).join('、') }}</template>
        </el-table-column>
        <el-table-column label="库位" min-width="200" header-align="center" align="left">
          <template slot-scope="s"><warehouse-location-select v-model="s.row.wareHouseId" :disabled="formDisabled || outboundFifoEnabled" size="small" @change="refreshUsable" /></template>
        </el-table-column>
        <el-table-column prop="allocationText" label="系统分配" min-width="160" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column v-if="!formDisabled" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="s">
            <el-button type="text" size="small" @click="removeLine(s.$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>
    </span>
    <el-dialog title="选择生产工单（可多选）" :visible.sync="orderDlg" width="960px" append-to-body>
      <el-form :inline="true" :model="orderQuery" size="small" class="issue-order-query">
        <el-form-item label="工单号">
          <el-input v-model="orderQuery.productionOrderCode" clearable placeholder="工单号" style="width:160px" @keyup.enter.native="searchOrders" />
        </el-form-item>
        <el-form-item label="产品编码">
          <el-input v-model="orderQuery.materialCode" clearable placeholder="产品编码" style="width:160px" @keyup.enter.native="searchOrders" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchOrders">查询</el-button>
          <el-button @click="resetOrderQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="orderTable" :data="filteredOrderList" border max-height="420" :header-cell-style="headStyle" @selection-change="onOrderSelectionChange">
        <el-table-column type="selection" width="45" header-align="center" align="center" />
        <el-table-column prop="productionOrderCode" label="工单号" min-width="150" header-align="center" align="left" />
        <el-table-column prop="materialCode" label="产品编码" min-width="140" header-align="center" align="left" />
        <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="left">
          <template slot-scope="s">{{ statusLabel(s.row.orderStatus) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="orderDlg = false">取消</el-button>
        <el-button type="primary" @click="confirmOrders">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import request from '../../api/request'
import inventoryOutboundFifoMixin from '../../mixins/inventory-outbound-fifo'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'ProductionIssueAddOrUpdate',
  mixins: [inventoryOutboundFifoMixin],
  components: { WorkflowDocButtons, WarehouseLocationSelect },
  data() {
    return {
      visible: false,
      readonly: false,
      orders: [],
      orderDlg: false,
      orderQuery: { productionOrderCode: '', materialCode: '' },
      pendingOrderSelection: [],
      orderFilter: { productionOrderCode: '', materialCode: '' },
      detailRequestId: 0,
      permCodes: [],
      form: { lines: [], orderIds: [], orderCodes: [] },
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: { bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }] }
    }
  },
  computed: {
    formDisabled() { return this.readonly || String(this.form.approveStatus) === '2' },
    showViewToolbar() { return this.readonly && !!this.form.id },
    dialogTitle() {
      if (this.readonly) return '领料详情'
      return this.form.id ? '修改领料' : '新增领料'
    },
    orderSummary() {
      const codes = this.form.orderCodes || []
      if (!codes.length) {
        const ids = this.form.orderIds || []
        if (!ids.length) return this.form.productionOrderCode || ''
        return '已选' + ids.length + '张工单'
      }
      if (codes.length === 1) return codes[0]
      return codes[0] + ' 等' + codes.length + '单'
    },
    filteredOrderList() {
      const code = (this.orderFilter.productionOrderCode || '').trim().toLowerCase()
      const mat = (this.orderFilter.materialCode || '').trim().toLowerCase()
      return (this.orders || []).filter(o => {
        if (!(o.orderStatus === '1' || o.orderStatus === '3' || !o.orderStatus)) return false
        if (code && String(o.productionOrderCode || '').toLowerCase().indexOf(code) < 0) return false
        if (mat && String(o.materialCode || '').toLowerCase().indexOf(mat) < 0) return false
        return true
      })
    }
  },
  created() {
    this.loadOutboundFifoPolicy()
    this.loadPerms()
    this.loadOrders()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadOrders(includeId) {
      const include = includeId || (this.form && (this.form.productionOrderId || (this.form.orderIds && this.form.orderIds[0]))) || ''
      return request.get('/production/order/ordersForBiz', { params: { includeProductionOrderId: include } })
        .then(res => { this.orders = res.data || [] }).catch(() => { this.orders = [] })
    },
    blankLine() { return { materialId: '', materialCode: '', materialName: '', quantity: 1, wareHouseId: '' } },
    statusLabel(s) { return s === '1' ? '已下达' : s === '3' ? '已完工' : (s || '') },
    syncOrderCodes() {
      const ids = this.form.orderIds || []
      this.form.orderCodes = ids.map(id => {
        const hit = (this.orders || []).find(o => o.productionOrderId === id)
        return hit ? hit.productionOrderCode : ''
      }).filter(Boolean)
      if (ids.length === 1) {
        this.form.productionOrderId = ids[0]
        this.form.productionOrderCode = this.form.orderCodes[0] || ''
      } else {
        this.form.productionOrderId = ''
        this.form.productionOrderCode = this.orderSummary
      }
    },
    pickOrder() {
      this.orderQuery = { productionOrderCode: '', materialCode: '' }
      this.orderFilter = { productionOrderCode: '', materialCode: '' }
      this.orderDlg = true
      this.loadOrders((this.form.orderIds || [])[0] || '').then(() => {
        this.$nextTick(() => this.restoreOrderSelection())
      })
    },
    searchOrders() {
      this.orderFilter = {
        productionOrderCode: this.orderQuery.productionOrderCode || '',
        materialCode: this.orderQuery.materialCode || ''
      }
      this.$nextTick(() => this.restoreOrderSelection())
    },
    resetOrderQuery() {
      this.orderQuery = { productionOrderCode: '', materialCode: '' }
      this.searchOrders()
    },
    restoreOrderSelection() {
      const table = this.$refs.orderTable
      if (!table) return
      table.clearSelection()
      const selectedIds = new Set(this.form.orderIds || [])
      this.filteredOrderList.forEach(row => {
        if (selectedIds.has(row.productionOrderId)) table.toggleRowSelection(row, true)
      })
    },
    onOrderSelectionChange(rows) {
      this.pendingOrderSelection = rows || []
    },
    confirmOrders() {
      const rows = this.pendingOrderSelection || []
      if (!rows.length) {
        this.$message.warning('请至少选择一个生产工单')
        return
      }
      this.form.orderIds = rows.map(r => r.productionOrderId)
      this.form.orderCodes = rows.map(r => r.productionOrderCode)
      this.syncOrderCodes()
      this.form.lines = []
      this.orderDlg = false
      this.$nextTick(() => this.fillBom())
    },
    removeLine(index) {
      this.form.lines.splice(index, 1)
    },
    editFromView() {
      this.readonly = false
      this.$nextTick(() => {
        if (this.$refs.issueLinesTable) this.$refs.issueLinesTable.doLayout()
      })
    },
    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },
    onClosed() {
      this.detailRequestId++
      this.readonly = false
      this.orderDlg = false
      this.form = { lines: [], orderIds: [], orderCodes: [] }
    },
    init(idOrRow, readonly) {
      const requestId = ++this.detailRequestId
      this.visible = true
      this.readonly = !!readonly
      if (this.readonly && idOrRow) {
        const openView = prefill => {
          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')
          const linkedOrders = Array.isArray(prefill.orders) ? prefill.orders : []
          const ids = linkedOrders.map(row => row.productionOrderId).filter(Boolean)
          const orderIds = ids.length ? ids : (prefill.productionOrderId ? [prefill.productionOrderId] : [])
          const orderCodes = linkedOrders.map(row => row.productionOrderCode).filter(Boolean)
          this.form = {
            id: prefill.id, code: prefill.code || '', bizDate,
            productionOrderId: prefill.productionOrderId || (orderIds.length === 1 ? orderIds[0] : ''),
            orderIds, orderCodes: orderCodes.length ? orderCodes : (prefill.productionOrderCode ? [prefill.productionOrderCode] : []),
            productionOrderCode: prefill.productionOrderCode || '', approveStatus: String(prefill.approveStatus || '0'),
            remark: prefill.remark || '', lines: Array.isArray(prefill.lines) ? prefill.lines : []
          }
          if (orderIds.length) this.mergeBom(requestId)
        }
        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow
        if (id) {
          request.get('/production/issue/info', { params: { id } }).then(res => {
            if (requestId === this.detailRequestId && this.visible) openView(res.data || {})
          }).catch(() => {
            if (requestId === this.detailRequestId && this.visible) this.$message.error('加载领料详情失败')
          })
        }
        return
      }
      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null
      const preset = (prefill && prefill.productionOrderId) || ''
      const presetCode = (prefill && prefill.productionOrderCode) || ''
      this.form = { code: '', bizDate: today(), productionOrderId: preset, orderIds: preset ? [preset] : [], orderCodes: presetCode ? [presetCode] : [], productionOrderCode: presetCode, remark: '', lines: preset ? [] : [this.blankLine()] }
      if (preset) this.loadOrders(preset).then(() => this.syncOrderCodes())
    },
    fillBom() {
      const ids = this.form.orderIds || []
      if (!ids.length) return
      request.get('/production/issue/bomLines', { params: { productionOrderIds: ids.join(','), excludeIssueId: this.form.id || '' } }).then(res => {
        this.form.lines = (res.data || []).map(row => Object.assign({ quantity: Number(row.remainIssueQty || 0), wareHouseId: row.wareHouseId || '' }, row))
        if (!this.form.lines.length) this.$message.warning('没有可领子件')
        this.refreshUsable()
      }).catch(() => {})
    },
    mergeBom(requestId = this.detailRequestId) {
      const ids = this.form.orderIds || []
      if (!ids.length) return
      request.get('/production/issue/bomLines', { params: { productionOrderIds: ids.join(','), excludeIssueId: this.form.id || '' } }).then(res => {
        if (requestId !== this.detailRequestId || !this.visible) return
        const byMaterial = {}
        ;(res.data || []).forEach(row => { byMaterial[row.materialId] = row })
        this.form.lines = (this.form.lines || []).map(line => {
          const hit = byMaterial[line.materialId] || {}
          return Object.assign({}, hit, line, { quantity: Number(line.quantity || 0), allocs: hit.allocs || line.allocs || [] })
        })
        this.refreshUsable()
      }).catch(() => {})
    },
    formatUsable(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      return Number.isNaN(n) ? '-' : n.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    usableShort(line) {
      const need = Number(line && line.quantity || 0)
      const usable = Number(line && line.usableQuantity)
      return need > 0 && !Number.isNaN(usable) && need > usable
    },
    refreshUsable() {
      const lines = (this.form.lines || []).filter(line => line && line.materialId)
      if (!lines.length || this.formDisabled) return
      const payload = lines.map(line => ({
        materialId: line.materialId,
        wareHouseId: this.outboundFifoEnabled ? '' : (line.wareHouseId || '')
      }))
      request.post('/production/issue/usable', { lines: payload }).then(res => {
        const rows = res.data || []
        lines.forEach((line, index) => {
          const hit = rows[index] || {}
          this.$set(line, 'usableQuantity', hit.usableQuantity == null ? 0 : hit.usableQuantity)
        })
      }).catch(() => {})
    },
    fillMaterial(row) {
      const code = (row.materialCode || '').trim()
      if (!code) return
      request.get('/base/material/byCode', { params: { materialCode: code } }).then(res => {
        const m = res.data || {}
        row.materialId = m.materialId || ''
        row.materialName = m.materialName || ''
        row.materialCode = m.materialCode || code
        this.refreshUsable()
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const ids = this.form.orderIds || []
        const lines = this.form.lines.filter(line => line.materialId && Number(line.quantity) > 0)
        if (!lines.length) { this.$message.warning(ids.length ? '请按BOM带出并填写领料数量' : '请填写物料'); return }
        request.post('/production/issue/save', {
          id: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: ids.length === 1 ? ids[0] : '', productionOrderIds: ids, remark: this.form.remark,
          lines: lines.map(line => ({
            materialId: line.materialId, orderBomId: line.orderBomId || ((line.allocs || [])[0] && line.allocs[0].orderBomId) || '',
            quantity: line.quantity, wareHouseId: line.wareHouseId, remark: '',
            allocs: (line.allocs || []).map(alloc => ({
              productionOrderId: alloc.productionOrderId, productionOrderCode: alloc.productionOrderCode,
              orderBomId: alloc.orderBomId, quantity: alloc.quantity, remainIssueQty: alloc.remainIssueQty
            }))
          }))
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      })
    },
    approve(yes) {
      const path = yes ? '/production/issue/approve' : '/production/issue/unapprove'
      const run = () => request.post(path, { id: this.form.id }).then(() => { this.$message.success('操作成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      if (yes) this.$confirm('审核后将扣减库存，是否继续？', '提示', { type: 'warning' }).then(run).catch(() => {})
      else run()
    },
    remove() {
      this.$confirm('删除后将释放已占用的可用量，是否继续？', '提示', { type: 'warning' }).then(() => {
        request.post('/production/issue/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
.qty-warn { color: #f56c6c; }
</style>
